/*
 * QuotationsSort Messages
 *
 * This contains all the text for the QuotationsSort container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.QuotationsSort';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Preventivi trovati',
  },
  title_short: {
    id: `${scope}.title_short`,
    defaultMessage: 'Trovati',
  },
  sort: {
    id: `${scope}.sort`,
    defaultMessage: 'Ordina per:',
  },
  remove: {
    id: `${scope}.remove`,
    defaultMessage: 'Rimuovi i filtri',
  },
  query: {
    id: `${scope}.query`,
    defaultMessage: 'Hai cercato: ',
  },
  download_list: {
    id: `${scope}.download_list`,
    defaultMessage: 'Scarica in formato .xlsx',
  },
  download_list_short: {
    id: `${scope}.download_list_short`,
    defaultMessage: 'Scarica .xlsx',
  },
});
